import React from "react";
import "./Loading.css";
import logo from "../../assets/logo.png";

const Loading = () => {
  return (
    <div className="loading-page">
      <div className="loading-content">
        <div className="logo-wrapper">
          <img src={logo} alt="Loading..." className="loading-logo" />
          <div className="logo-pulse"></div>
        </div>
        <div className="modern-spinner">
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="dot"></div>
        </div>

      </div>
    </div>
  );
};

export default Loading;
